import {
  ServiceAppointment as Appointment,
  AppointmentCase,
  ServiceAppointmentDeclinedMpviCode
} from '@quorum/models/xs-resource';

import { Action } from '@ngrx/store';

export const GET_APPOINTMENT_FROM_SERVER = '[FIXED OPERATIONS] Get Appointment From Server';
export class GetAppointmentFromServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_APPOINTMENT_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: number; query: any }) {}
}

export const GET_APPOINTMENT_FROM_SERVER_SUCCESS = '[FIXED OPERATIONS] Get Appointment From Server Success';
export class GetAppointmentFromServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_APPOINTMENT_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: Appointment) {}
}

export const GET_APPOINTMENT_FROM_SERVER_FAILURE = '[FIXED OPERATIONS] Get Appointment From Server Failure';
export class GetAppointmentFromServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_APPOINTMENT_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_APPOINTMENT_CASE_TO_SERVER = '[FIXED OPERATIONS] Post Appointment Case To Server';
export class PostAppointmentCaseToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_CASE_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: AppointmentCase }) {}
}

export const POST_APPOINTMENT_CASE_TO_SERVER_SUCCESS = '[FIXED OPERATIONS] Post Appointment Detail To Server Success';
export class PostAppointmentCaseToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_CASE_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: AppointmentCase }) {}
}

export const POST_APPOINTMENT_CASE_TO_SERVER_FAILURE = '[FIXED OPERATIONS] Post Appointment Detail To Server Failure';
export class PostAppointmentCaseToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_CASE_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER =
  '[FIXED OPERATIONS] Post Appointment Declined Service To Server';
export class PostAppointmentDeclinedServiceToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { declinedService: ServiceAppointmentDeclinedMpviCode; rooftop?: number }) {}
}

export const POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER_SUCCESS =
  '[FIXED OPERATIONS] Post Appointment Declined Service To Server Success';
export class PostAppointmentDeclinedServiceToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { declinedService: ServiceAppointmentDeclinedMpviCode }) {}
}

export const POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER_FAILURE =
  '[FIXED OPERATIONS] Post Appointment Declined Service To Server Failure';
export class PostAppointmentDeclinedServiceToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_APPOINTMENT_DECLINED_SERVICE_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type AppointmentsAction =
  | GetAppointmentFromServer
  | GetAppointmentFromServerSuccess
  | GetAppointmentFromServerFailure
  | PostAppointmentCaseToServer
  | PostAppointmentCaseToServerSuccess
  | PostAppointmentCaseToServerFailure
  | PostAppointmentDeclinedServiceToServer
  | PostAppointmentDeclinedServiceToServerSuccess
  | PostAppointmentDeclinedServiceToServerFailure;
